module.exports = __webpack_public_path__ + "img/mask-triangle_2_1.fabca9bb.svg";